module.exports = __webpack_public_path__ + "img/zs6.e770cdbf.png";